module.exports = __webpack_public_path__ + "media/images/ic-index-suspicious-723f5a48928bf2a747f157f6686dcab3.svg";